<template>
  <el-dialog title="Duplicar Imóvel" @open="reset" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      <el-form-item style="width: 100%">
        <el-switch v-model="parametros.informacoesProprietario" active-text="Informações do Proprietário"/>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-switch v-model="parametros.caracteristicasImovel" active-text="Características do Imóvel"/>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-switch v-model="parametros.caracteristicasCondominio" active-text="Características do Condomínio"/>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-switch v-model="parametros.captadores" active-text="Captadores"/>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-switch v-model="parametros.informacoesAdicionais" active-text="Informações Adicionais"/>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-switch v-model="parametros.outrasInformacoes" active-text="Outras Informações"/>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="duplicar" type="primary" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    visitaSelecionada: Object
  },
  data() {
    return {
      parametros: {
        informacoesProprietario: false,
        caracteristicasImovel: false,
        caracteristicasCondominio: false,
        captadores: false,
        informacoesAdicionais: false,
        outrasInformacoes: false
      }
    }
  },
  computed: {
    ...mapState('vendasImoveisStore', {
      imovel(state) { return state.imovelSelecionado }
    }),
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('vendasImoveisStore', [
      'duplicarImovel'
    ]),
    reset() {
      this.parametros = {
        informacoesProprietario: false,
        caracteristicasImovel: false,
        caracteristicasCondominio: false,
        captadores: false,
        informacoesAdicionais: false,
        outrasInformacoes: false,
        imovel: this.imovel,
        isLancamento: this.imovel.categoria === 'LANCAMENTO',
      }
    },
    duplicar() {
      this.duplicarImovel(this.parametros);
      this.fechar();
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>

